import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCustomerAdminComponent } from '../add-customer-admin/add-customer-admin.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { countryCodes } from '../../../../constants/country-codes';
import { DropDownConfig } from '../../../../interfaces/dropdown.config';
import { DataService } from '../../../../services/data.service';
import { EnvService } from '../../../..//services/env.service';
import { HttpService } from '../../../../services/http.service';
import { AppStateService } from '../../../../services/app-state.service';
import { UtilsService } from '../../../../services/utils.service';
import { isEmptyObject, isNullOrUndefined } from '../../../../modules/shared';
import { MatStepper } from '@angular/material/stepper';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';

@Component({
  selector: 'app-add-or-edit-customer',
  templateUrl: './add-or-edit-customer.component.html',
  styleUrls: ['./add-or-edit-customer.component.scss']
  // providers: [HttpService]
})
export class AddOrEditCustomerComponent implements OnInit {

  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  isEmailValid: boolean = true;

  isCustomerDropdownRequired: boolean = false;
  customerDropDownValues: DropDownConfig[] = [];
  selectedTypeValues: any = {};
  customerAttributes: any[] = [];
  areCustomerAttributesFilled: boolean = false;

  isApplicationTableDataLoaded: boolean = false;
  // showDropDown : boolean = true;

  isPrimaryMobileNoValid: boolean = true;
  isSecondaryMobileNoValid: boolean = true;
  currentCountryCode: string = "in";

  customerDetails: any = {
    customerName: null,
    email: null,
    primaryMobileNo: null,
    secondaryMobileNo: null,
    address: null,
    billingAddress: null,
    editPrimaryMobileNo: null
  };

  formDataCopy: any = {
    billing_address: null,
    com_address: null,
    email: null,
    name: null,
    primary_contact: null,
    secondary_contact: null
  }

  billingAddressToggleFlag: boolean = false;
  isEdit: boolean = true;
  customerAdmin: any = null;
  customerId: any = null;
  subscriptions: Subscription[] = [];
  operation: any;

  assignedResources: any = {};
  operationType: any;

  applicationsResourcesInfo: any = {};
  isApplicationsAssigned: boolean = false;
  hasAssignedResources: boolean = false;
  showCustomerAdmin: boolean = false;
  customerAdminEmail: any = null;

  countryCodeList: any[] = [...countryCodes];

  secondaryContactValid: boolean = true;

  primaryMobileForm = new FormGroup({
    primaryMobileNo: new FormControl(undefined, [Validators.required]),
  });

  customerNameForm = new FormGroup({
    customerName: new FormControl('', [Validators.required]),
  });
  customerEmailForm = new FormGroup({
    customerEmail: new FormControl('', [Validators.required,Validators.pattern(this.emailPattern)])
  });

  secondaryMobileForm = new FormGroup({
    secondaryMobileNo: new FormControl(undefined),
  });


  nextStepValidForm = new FormGroup({
    nextStepValid: new FormControl('',[Validators.required]),
  });

  nextSecondStepValidForm = new FormGroup({
    nextStepValid: new FormControl('',[Validators.required]),
  });


  customerAdminForm = new FormGroup({
  firstName: new FormControl('', Validators.required),
  lastName: new FormControl('', Validators.required),
  email: new FormControl('', [Validators.required, Validators.email])

});

  stepConfig: {
    info: number,
    admin: number,
    resources: number
  } = {
    info: 1,
    admin: 0,
    resources: 0
  }
  customerAdminInfo: any;
  customerAdminInfoDetails : any;
  currentTab: string = 'info';
  currentTabIndex: number = 0;
  applicationsList: any[] = [];
  applicationSelectedStatus: any = {};
  applicationSelectedStatusCopy: any = {};

  //* Map of application names to application id's
  applicationNameIdMap: any = {};

  //* Map of application names to resource action id's
  applicationNameResourceActionIdMap: any = {};

  applicationNames: string[] = [];
  applicationIds: string[] = [];

  isButtonEnabled: boolean = false;

  /**for mat stepper validation functionality */
   isCustomerInfoStepCompleted = false;
   isAddAdminStepCompleted = false;

  modalTitle: any = null;
  buttonText: any = null;
  payloaddata: any = { applicationIdsToDelete: [], customerId: '', resourceActionIdsToAdd: [], applicationIdsToAdd: [], resourceActionIdsToDelete: [] };
  applicationIdsToAdd: any = [];
  applicationIdsToDelete: any = [];
  unchekedList: any = [];
  chekedList: any = [];
  appsListWithResources: any;
  loading: boolean = true;
  @ViewChild("stepper", { static: false }) stepper!: MatStepper;
  @ViewChild('phone') phoneComponent!: NgxMatIntlTelInputComponent;
  isCustomerNameEmpty: boolean=false;

  constructor(
    private modal: NgbModal,
    private httpSrv: HttpService,
    private utilSrv: UtilsService,
    private appState: AppStateService,
    private dataSrv: DataService,
    private envService: EnvService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  async ngOnInit() {


    let customerData = this.appState.getCustomerData();

    this.isCustomerDropdownRequired = this.envService.isCustomerDropdownRequired;
    this.customerDropDownValues = this.isCustomerDropdownRequired? await this.fetchCustomerTypeValues(): [];
    this.areCustomerAttributesFilled = this.isCustomerDropdownRequired ? false : true;
    this.loading = true;
    if(customerData) {
      this.setInitialCustomerInfo();
    }

    let dropDownLabels = this.customerDropDownValues.map((item: any) => item.label);

    for (let label of dropDownLabels) {
      this.selectedTypeValues[label] = null;
    }

    const queryParamsRef = this.route.queryParams.subscribe(async (params: Params) => {
      this.loading = true;
      let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;
      const tabs = Object.keys(this.stepConfig);
      let operation = params['operation'];
      let customerId = params['customerId'];

      this.operation = operation;

      this.isEdit = this.operation === CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER ? true : false;

      this.areCustomerAttributesFilled = this.isEdit && this.isCustomerDropdownRequired ? true : false;

      this.isApplicationTableDataLoaded = this.operation === CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER ? true : false;

      if (!isNullOrUndefined(customerId)) {
        this.appState.setCurrentCustomerId(customerId);
        this.customerId = customerId;
      }

      if (operation === CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER || operation === CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER) {
        if (params['config'] && tabs.includes(params['config'])) {
          this.currentTab = params['config'];
          tabs.forEach((tab: string, index: number) => {
            if (tab == params['config']) {
              this.currentTabIndex = index;
              this.stepConfig[tab as keyof typeof this.stepConfig] = 1;
            } else {
              this.stepConfig[tab as keyof typeof this.stepConfig] = 0;
            }
          })
        }
        await this.handleViewOrEditCustomerOnRefresh(customerId);
      }else {
        if(this.currentTab == 'resources') {
          //* Get all assigned resources for all assigned apps
          //* for a customer Api Call
          this.fetchAllActiveApplications(customerId);
          this.fetchAllAssignedResourcesUnderAssignedAppsForCustomer(customerId);
        }
      }
      this.loading = false;
    })

    this.subscriptions.push(queryParamsRef);

   
  }

  fetchCustomerTypeValues(): Promise<DropDownConfig[]> {
    const postData = {};
    const promise = new Promise<DropDownConfig[]>((resolve, reject) => {
      const dropDownDetails: DropDownConfig = {
        label: 'cust_type_uuid',
        values: []
      }
      this.httpSrv.makePostApiCall('FETCH_CUSTOMER_TYPE', postData, this.envService.applicationBaseUrl).subscribe({
        next: (customerType: any[]) => {
          console.log(customerType);
          dropDownDetails.values = customerType
          resolve([dropDownDetails]);
        },
        error: () => {
          resolve([dropDownDetails])
        }
      })
    })
    return promise;
  }

  onToggleTab(event: any) {
    const steps = ['info','admin','resources']
    const tabs = Object.keys(this.stepConfig);
    if (true) {
      this.currentTab = steps[event?.selectedIndex];
      tabs.forEach((tabs: any) => {
        if (tabs === steps[event?.selectedIndex]) {
          this.router.navigate(['um', 'customer', 'addCustomer'], {
            queryParams: {
              config: steps[event?.selectedIndex]
            },
            queryParamsHandling: 'merge'
          })
          this.stepConfig[tabs as keyof typeof this.stepConfig] = 1;
        } else {
          this.stepConfig[tabs as keyof typeof this.stepConfig] = 0;
        }
      });
    }
    if(event?.selectedIndex!=2){
      this.stepper.steps.forEach(step => step.completed = false);
    }
  }

  navigateToCustomerView() {
    this.router.navigate(['um', 'customer', 'addCustomer'], {
      queryParamsHandling: 'merge'
    });
  }

  assignOrUpdateResources() {
    if (this.unchekedList.length > 0) {
      const data = this.appsListWithResources.response
      for (let key in this.unchekedList) {
        for (let key1 in data) {
          if (this.unchekedList[key] == key1) {
            if (!isEmptyObject(data[key1])) {
              this.payloaddata['applicationIdsToDelete'].push(data[key1]['Dashboards'][0]['applicationId'])
              for (let dat in data[key1]['Dashboards']) {
                this.payloaddata['resourceActionIdsToDelete'].push(data[key1]['Dashboards'][dat]['resourceActionId'])
              }
            }else {
              for (let i = 0; i < this.applicationsList.length; i++) {
                if (this.applicationsList[i]['applicationName'] == key1) {
                  this.payloaddata['applicationIdsToDelete'].push(this.applicationsList[i]['applicationId'])
                }
              }
            }
          }
        }
      }
      this.payloaddata['customerId'] = this.customerId;
    }
    else {
      this.payloaddata['customerId'] = this.customerId;
      for (let key in this.chekedList) {
        this.payloaddata['applicationIdsToAdd'].push(this.chekedList[key])
      }
    }
      this.httpSrv.makePostApiCall('ASSIGN_OR_UPDATE_RESOURCES', this.payloaddata, this.envService.baseUrl).subscribe({
        next: (response: any) => {
          this.utilSrv.showToastMessage("Resources updated successfully ", "success");
          this.router.navigate(['um', 'customer']);
        },
        complete: () => {},
        error: () => {
          this.utilSrv.showToastMessage("Error in assigning/updating resources", "error");
        }
      });
  }

  async handleViewOrEditCustomerOnRefresh(customerId: any) {

    if(this.currentTab == 'resources') {
      //* Get all assigned resources for all assigned apps
      //* for a customer Api Call
      this.fetchAllActiveApplications(customerId);
      this.fetchAllAssignedResourcesUnderAssignedAppsForCustomer(customerId);
    }else if(this.currentTab != 'resources') {
      const options = {
        "uriParams": {
          customerId
        }
      };
      //* Get customer info by customer id api call
      let customerInfo = await this.dataSrv.getCustomerInfoByCustomerId(options);

      //* API call to fetch customer type dropdown values
      await this.fetchCustomerAttributes(customerInfo);
      //* Get customer admin info by customer id api call
      this.customerAdminInfo = await this.dataSrv.getCustomerAdminInfoByCustomerId(options);
      this.customerAdminInfoDetails = this.customerAdminInfo.response ? this.customerAdminInfo.response[0]:undefined;
      let { response: customerAdminResponse } = this.customerAdminInfo;
  
      if (this.utilSrv.isObjectNotNullAndEmpty(customerInfo)
        && this.utilSrv.isObjectNotNullAndEmpty(this.customerAdminInfo)) {
        let { response } = customerInfo;
        
        response['customerAdminEmail'] = customerAdminResponse.length > 0
          ? customerAdminResponse[0].email_id
          : null;
  
        this.showCustomerAdmin = !isNullOrUndefined(response['customerAdminEmail']) ? false : true;
  
        this.setCustomerDetails(response);
      }
    }
  }

  validateEmail(event: any) {
    let inputStr = event.target.value;
    this.isEmailValid = this.utilSrv.isEmailValid(this.emailPattern, inputStr);
    this.customerDetails.email = inputStr;
  }

  setInitialCustomerInfo() {
    let { info, operation } = this.appState.getCustomerData();

    this.operation = operation;
    this.isApplicationTableDataLoaded = this.operation === 'new' ? true : false;

    if (!isNullOrUndefined(info)) {
      let { customerAdminEmail } = info;
      this.customerAdminEmail = customerAdminEmail;
      this.showCustomerAdmin = !isNullOrUndefined(customerAdminEmail) || operation === 'new' ? false : true;
    }

    if (operation === 'edit' || operation === 'view') {
      this.appState.setCurrentCustomerId(info.customerId);
      if(this.currentTab == 'info') {
        this.setCustomerDetails(info);
      }
      this.customerId = info.customerId;

      if (operation === 'view') {
        this.isEdit = false;
      }

      if ((this.isEdit || operation === 'view') && this.isCustomerDropdownRequired && this.currentTab != 'resources') {
        this.fetchCustomerAttributes();
      }

      if (this.customerDetails.address && this.customerDetails.billingAddress && this.customerDetails.address === this.customerDetails.billingAddress) {
        this.billingAddressToggleFlag = true;
      }
    }
  }

  setCustomerDetails(postData: any) {
    let primaryContact = postData['primaryContact'] ? postData['primaryContact'] : null;
    let secondaryContact = postData['secondaryContact'] ? postData['secondaryContact'] : null;
    let editPrimaryContact = primaryContact !== null ? primaryContact.substring(primaryContact.length - 10, primaryContact.length) : null
    let editSecondaryContact = secondaryContact !== null ? secondaryContact.substring(secondaryContact.length - 10, secondaryContact.length) : null
     const customerDetailsJson = postData['customerDetailsJson'];
    const ValidJson = typeof customerDetailsJson === 'string' ? JSON.parse(customerDetailsJson) : typeof customerDetailsJson === 'object' && customerDetailsJson !== null 
    && customerDetailsJson.hasOwnProperty('value')
      ? JSON.parse(customerDetailsJson.value)
      : customerDetailsJson;

    const customerTypeId = ValidJson?.['cust_type_uuid'] ?? null;
    const customerType = this.isCustomerDropdownRequired? this.customerDropDownValues[0].values.find((type: any) => type['cust_type_uuid'] == customerTypeId): '';
    this.selectedTypeValues['cust_type_uuid'] = customerType? customerType['cust_type_name']: null;
    this.customerDetails = {
      customerName: postData['customerName'] ? postData['customerName'] : null,
      email: postData['email'] ? postData['email'] : null,
      primaryMobileNo: primaryContact,
      secondaryMobileNo: secondaryContact,
      address: postData['address'] ? postData['address'] : null,
      billingAddress: postData['billingAddress'] ? postData['billingAddress'] : null,
      customerAdminEmail: !isNullOrUndefined(this.customerAdminEmail)
        ? this.customerAdminEmail : postData['customerAdminEmail'],
    }

    // this.primaryMobileForm.controls.primaryMobileNo.setValue(editPrimaryContact);
    this.primaryMobileForm.controls.primaryMobileNo.setValue(primaryContact);
    this.customerNameForm.controls.customerName.setValue(postData['customerName'] ? postData['customerName'] : null)
    this.customerEmailForm.controls.customerEmail.setValue(postData['email'] ? postData['email'] : null)
    // this.secondaryMobileForm.controls.secondaryMobileNo.setValue(editSecondaryContact);
    this.secondaryMobileForm.controls.secondaryMobileNo.setValue(secondaryContact);

    if (!isNullOrUndefined(this.customerDetails['customerAdminEmail'])) {
      this.customerAdminEmail = this.customerDetails['customerAdminEmail'];
    }

    this.formDataCopy = {
      name: this.customerDetails['customerName'],
      email: this.customerDetails['email'],
      primary_contact: this.customerDetails['primaryMobileNo'],
      secondary_contact: this.customerDetails['secondaryMobileNo'],
      com_address: this.customerDetails['address'],
      billing_address: this.customerDetails['billingAddress'],
    }

  }

  //TODO: Check for other ways of validating fields which can have
  //only alphabets, this is not "Angular" way of doing
  onlyAlphabet(event: any) {
    const pattern = /[a-zA-Z0-9\s]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent, key: any) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    let trimmedText = pastedText?.replace(/[^a-zA-Z]/g, '');
    this.customerDetails[key] = '';
    setTimeout(() => {
      trimmedText = trimmedText?.substr(0, 25);
      this.customerDetails[key] = trimmedText;
    }, 1);
  }

  onlyDigit(key: any, id: any) {
    var input = document.getElementById(id);
    var pattern = /^[1-9][0-9]{0,9}$/;
    if (input) {
      var value: any = input['value' as keyof typeof input];
      !pattern.test(value) && (input['value' as keyof typeof input] == value) && (input['value' as keyof typeof input] == '');
      input.addEventListener('input', () => {
        var currentValue = this.customerDetails[key];
        if (currentValue && !pattern.test(currentValue)) this.customerDetails[key] = value;
        else value = currentValue;
      });
    }
  }

  /**
   * 1. If checkbox is clicked then copy comm_addr to billing addr
   * 2. If checkbox is unselected then the fields are independent
   * 3. If checkbox is selected and billing_addr is modified then update comm_addr
   */

  onLog()
  {
    console.log(this.primaryMobileForm.value)
  }

  billingAddressToggle() {
    this.billingAddressToggleFlag = !this.billingAddressToggleFlag;

    this.onCommAddressChanged();
    this.onBillingAddressChanged();
  }

  onCommAddressChanged(event: any = null) {
    this.customerDetails.billingAddress = this.billingAddressToggleFlag
      ? this.customerDetails.address : '';
  }

  onBillingAddressChanged(event: any = null) {
    this.customerDetails.address = this.billingAddressToggleFlag
      ? this.customerDetails.billingAddress : this.customerDetails.address;
  }

  onEditClick() {
    this.isEdit = true;
  }

  navigateToCustomerList() {
    this.router.navigate(['um', 'customer']);
  }

  navigateToEditView() {

    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    if (!isNullOrUndefined(this.customerId)) {
      this.router.navigate(['um', 'customer', 'addCustomer'], {
        queryParams: {
          operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER,
          customerId: this.customerId
        }
      });
    }
  }

  checkLength(event: any, type: string) {
    let value = event.target.value;
    if(this.primaryMobileForm.getRawValue()?.primaryMobileNo !=null && type === "primary"){
    const indexOfPlus = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).indexOf('+');
      let dialCode = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).slice(0, indexOfPlus + 3);
      let phoneNumberPart:any = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).slice(indexOfPlus + 3);
      if(dialCode == '+91' && !(phoneNumberPart.toString().length === 10)){
        this.isPrimaryMobileNoValid = false;
        this.primaryMobileForm.get('primaryMobileNo')?.setValue(undefined);
        this.primaryMobileForm.get('primaryMobileNo')?.updateValueAndValidity();
        return;
      }
    }else if(this.secondaryMobileForm.getRawValue()?.secondaryMobileNo !=null && type === "secondary"){
      const indexOfPlus = (this.secondaryMobileForm.getRawValue()?.secondaryMobileNo as any).indexOf('+');
      let dialCode = (this.secondaryMobileForm.getRawValue()?.secondaryMobileNo as any).slice(0, indexOfPlus + 3);
      let phoneNumberPart:any = (this.secondaryMobileForm.getRawValue()?.secondaryMobileNo as any).slice(indexOfPlus + 3);
      if(dialCode == '+91' && phoneNumberPart.toString().length > 10){
        this.isPrimaryMobileNoValid = false;
        this.secondaryMobileForm.get('secondaryMobileNo')?.setValue(undefined);
        this.secondaryMobileForm.get('secondaryMobileNo')?.updateValueAndValidity();
        return;
      }
    }
    if (value.length > 0) {
      if (type === 'primary') {
        this.isPrimaryMobileNoValid = this.primaryMobileForm.invalid ? false : true;
      } else if (type === 'secondary') {
        this.isSecondaryMobileNoValid = this.secondaryMobileForm.invalid ? false : true;
      }
    } else {
      if (type === 'primary') {
        this.isPrimaryMobileNoValid = true;
      } else if (type === 'secondary') {
        this.isSecondaryMobileNoValid = true;
      }
    }
  }

  onCustomerInfoStepCompleted(data:any) {
    this.isCustomerInfoStepCompleted = true;
    this.addCustomer(data);
  }
  onNameEntered(event:any){
    this.customerDetails.customerName = event.target.value;
    if(this.customerDetails.customerName?.trim() !==''){
      this.isCustomerNameEmpty = false; 
    } else{
      this.isCustomerNameEmpty = true; 
    }
  }

  onFormSubmit(form: NgForm) {
    let data = form.value;
    data.name = this.customerNameForm.getRawValue()?.customerName;
    data.email =this.customerEmailForm.getRawValue()?.customerEmail;
    if (this.customerId) {
      this.updateCustomer(data);
    } else {
      const obj = {"nextStepValid":'yes'};
      this.nextStepValidForm.patchValue(obj);
      this.onCustomerInfoStepCompleted(data);
      
    }
  }

  addCustomerAdmin() {
    const modalRef = this.modal.open(AddCustomerAdminComponent, USER_MGMT_CNST.MODAL_OPTIONS);

    modalRef.componentInstance.customerId = this.customerId;
    modalRef.componentInstance.customerName = this.customerDetails.customerName;

    modalRef.result.then((data) => {
      this.customerAdmin = data;
      this.showCustomerAdmin = Object.keys(this.customerAdmin).length > 0 ? false : true;
    });
  }

  addCustomer(data: any) {
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;
    
    let primaryContactControl: any = this.primaryMobileForm.controls['primaryMobileNo'].value;
    let secondaryContactControl: any = this.secondaryMobileForm.controls['secondaryMobileNo'].value;
    
    let postData = {
      meta: {
        customerName: data.name,
        purchasedPlan: null,
        primaryContact: primaryContactControl,
        secondaryContact: !isNullOrUndefined(secondaryContactControl) ? secondaryContactControl : null,
        email: data.email,
        address: data.com_address,
        billingAddress: data.billing_address,
        customerConfig: {
          dropDownConfig: this.areCustomerAttributesFilled ? this.customerAttributes : null
        }
      }
    };

    console.log(postData, 'postData add');
    
    this.httpSrv.makePostApiCall('ADD_CUSTOMER', postData, this.envService.baseUrl).subscribe({
      next: async (response: any) => {
        if (response.result) {
          this.isEdit = true;
          this.operation = CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER;
          this.customerId = response.response;

          this.showCustomerAdmin = !isNullOrUndefined(this.customerId) ? true : false;

          this.customerDetails.primaryMobileNo = postData.meta.primaryContact;
          this.customerDetails.secondaryMobileNo = postData.meta.secondaryContact;

          if (!isNullOrUndefined(this.customerId)) {
            this.stepConfig.info = 0;
            this.stepConfig.admin = 1;
            this.operation = 'edit';
            this.stepper.next();
            this.isEdit = this.operation === CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER ? true : false;

            this.areCustomerAttributesFilled = this.isEdit ? true : false;

            this.isApplicationTableDataLoaded = this.operation === CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER ? true : false;

            this.appState.setCurrentCustomerId(this.customerId);

            
          }

          this.appState.setCurrentCustomerId(this.customerId);
          // this.utilSrv.showToastMessage("Added customer successfully ", "success");
        }
      },
      complete: async () => {
        this.utilSrv.showToastMessage("Customer Added Successfully", "success");
        if(this.isCustomerDropdownRequired) {
          await this.setCutomerTypeToCustomer();
        }
        await this.handleViewOrEditCustomerOnRefresh(this.customerId);
      },
      error: (err: any) => {
        let { error } = err;

        if (this.utilSrv.isObjectNotNullAndEmpty(error)) {
          let { message } = error;

          if (!isNullOrUndefined(message)) {
            if(message.includes('customers_email_key')) {
              this.utilSrv.showToastMessage("Email Id Already Exists", "error");
            }else if(message.includes('customers_primary_contact_key')) {
              this.utilSrv.showToastMessage("Primary Mobile Number Already Exists", "error");
            }else if(message.includes('customers_customer_name_key')) {
              this.utilSrv.showToastMessage('Customer Already Exists', 'error');
            }else {
              this.utilSrv.showToastMessage("Error while adding customer", "error");
            }
          } else {
            this.utilSrv.showToastMessage("Error while adding customer", "error");
          }
        } else {
          this.utilSrv.showToastMessage("Error while adding customer", "error");
        }
      }
    });
  }

  setCutomerTypeToCustomer() {
    const promise = new Promise((resolve, reject) => {
      const postData = {
        cust_uuid:this.customerId,
        cust_type_uuid: this.selectedTypeValues['cust_type_uuid']
      }
      this.httpSrv.makePostApiCall('ADD_CUSTOMER_TYPE', postData, this.envService.applicationBaseUrl).subscribe({
        next: (res: any) => {
          resolve(true);
        },
        error: () => {
          resolve(false);
        }
      })
    })
    return promise;
  }

  getdata(data: any) {
    for (let key in this.applicationSelectedStatus) {
      if (this.applicationSelectedStatus[key] == true) {
        for (let data in this.applicationsList) {
          if (this.applicationsList[data]['applicationName'] == key && this.applicationsList[data]['status'] == false) {
            this.applicationIdsToAdd.push(this.applicationsList[data]['applicationId'])
          }
        }
      }
      else {
        for (let data in this.applicationsList) {
          if (this.applicationsList[data]['applicationName'] == key && this.applicationsList[data]['status'] == true) {
            this.applicationIdsToDelete.push(this.applicationsList[data]['applicationId'])
          }
        }
      }
    }
    this.payloaddata['applicationIdsToAdd'] = this.applicationIdsToAdd;
    this.payloaddata['customerId'] = data['customerId'];
    this.payloaddata['resourceActionIdsToAdd'] = data['assignResources'];
    this.payloaddata['applicationIdsToDelete'] = this.applicationIdsToDelete;;
    this.payloaddata['resourceActionIdsToDelete'] = data['deleteResources']
  }

  updateCustomer(data: any) {
    let primaryContactControl: any = this.primaryMobileForm.controls['primaryMobileNo'].value;
    let secondaryContactControl: any = this.secondaryMobileForm.controls['secondaryMobileNo'].value;

    let postData = {
      meta: {
        customerName: data.name,
        purchasedPlan: null,
        primaryContact: primaryContactControl,
        secondaryContact: !isNullOrUndefined(secondaryContactControl) ? secondaryContactControl : secondaryContactControl,
        email: data.email,
        address: data.com_address,
        billingAddress: data.billing_address,
        customerId: this.customerId,
        customerConfig: null
      }
    };

    let options = {
      uriParams: {
        "id": this.customerId
      }
    }

    let isFormValuesModified = this.dataSrv.areEditCustomerFormValuesModified(this.formDataCopy, data);

    if (isFormValuesModified) {

      this.httpSrv.makePostApiCall('UPDATE_CUSTOMER', postData, this.envService.baseUrl, options).subscribe({
        next: (response: any) => {
          if (response.result) {
            this.isEdit = false;

            let customerData = this.appState.getCustomerData();
            if (this.utilSrv.isObjectNotNullAndEmpty(customerData)) {
              customerData['operation'] = USER_MGMT_CNST.CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER,
                this.appState.setCustomerData(customerData);
            }

            this.customerDetails.primaryMobileNo = postData.meta.primaryContact;
            this.customerDetails.secondaryMobileNo = postData.meta.secondaryContact;
            if (this.stepConfig['info'] == 1) {
              this.stepConfig['info'] = 0;
              this.stepConfig['resources'] = 1;
            } else {

            }
            this.stepper.next();
            this.utilSrv.showToastMessage("Updated customer successfully ", "success");
          }
        },
        complete: async () => {
          await this.handleViewOrEditCustomerOnRefresh(this.customerId);
        },
        error: (err: any) => {
          if (err['code'] && err.code === 400) {
            this.utilSrv.showToastMessage(err.message, "error");
          } else {
            console.log("Error while updating customer ", err);
            this.utilSrv.showToastMessage(err['error']['message'], "error");
          }
        }
      });
    } else {
      this.utilSrv.showToastMessage("No field is edited for updating", "error");
    }
  }

  async fetchAllAssignedResourcesUnderAssignedAppsForCustomer(customerId: any = null) {
    
    // Api Parameters
    const options = {
      uriParams: {
        customerId: !isNullOrUndefined(customerId) ? customerId : this.appState.getCurrentCustomerId()
      }
    }
    this.appsListWithResources = await this.dataSrv.fetchAllResourcesForAllAssignedAppsByCustomerId(options);
    
    let applicationsListResponse = this.appsListWithResources;

    this.isApplicationTableDataLoaded = true;

    let { response } = applicationsListResponse;

    if (!isNullOrUndefined(response)) {
      this.applicationsResourcesInfo = response;

      let applicationKeys = Object.keys(this.applicationsResourcesInfo);
      this.isApplicationsAssigned = applicationKeys.length > 0 ? true : false;

      if (this.isApplicationsAssigned) {

        //* Check if atleast one application has any resources assigned
        //* If so make hasAssignedResources true and break the loop
        for (let i = 0; i < applicationKeys.length; i++) {

          let applicationName = applicationKeys[i];

          let hasResources = this.applicationsResourcesInfo[applicationName];
          let resourceKeys = Object.keys(hasResources);

          if (!isNullOrUndefined(hasResources) && resourceKeys.length > 0) {
            this.hasAssignedResources = true;
            break;
          }
        }
      }
    }
  }

  async fetchCustomerAttributes(customerInfo: any = null) {

    let customerId = !isNullOrUndefined(this.customerId)
      ? this.customerId
      : this.appState.getCurrentCustomerId();

    let options = {
      uriParams: {
        customerId
      }
    }

    if (!isNullOrUndefined(customerId)) {
      let customerAttributes: any;
      if(!customerInfo) {
        customerAttributes = await this.dataSrv.getCustomerInfoByCustomerId(options);
      }else {
        customerAttributes = customerInfo;
      }

      if (this.utilSrv.isObjectNotNullAndEmpty(customerAttributes)) {
        let { response } = customerAttributes;
        if (this.utilSrv.isObjectNotNullAndEmpty(response)) {
          let { customerConfig } = response;

          if (!isNullOrUndefined(customerConfig)) {
            let { dropDownConfig } = customerConfig;

            if (!isNullOrUndefined(dropDownConfig)) {
              dropDownConfig.forEach((config: any) => {
                let { label, values } = config;
                this.selectedTypeValues[label] = values[0];
              })
            }
          }
          this.areCustomerAttributesFilled = Object.values(this.selectedTypeValues).some(value => value !== '');
        }
      }
    }
  }


  catchCustomerAdminForm(event:any)
  {
    this.customerAdminForm = event;
  }

  customerAdminInfoDetailsEmitter(event : any){
    this.customerAdminInfoDetails = event;
  }
  onTypeChanged() {
    this.customerAttributes = this.dataSrv
      .buildCustomerAttributeValues(this.selectedTypeValues);

    this.areCustomerAttributesFilled = this.isCustomerAttributeValid();
  }

  isSecondaryContactValid() {
    let secondaryMobileNo: any = this.secondaryMobileForm.controls['secondaryMobileNo'].value;
    let isSecondaryMobileNullOrEmpty = isNullOrUndefined(secondaryMobileNo) || secondaryMobileNo === '';

    this.secondaryContactValid = this.secondaryMobileForm.valid || isSecondaryMobileNullOrEmpty;
  }

  isCustomerAttributeValid(): boolean {
    if (!this.isCustomerDropdownRequired) return this.areCustomerAttributesFilled;

    this.areCustomerAttributesFilled = this.customerAttributes.length > 0 &&
      this.dataSrv.checkIfAllAttributesAreFilled(this.customerAttributes);

    return this.areCustomerAttributesFilled;
  }

  fetchAllActiveApplications(customerId: any = null) {

    let options = {
      'uriParams': {
        customerId: customerId ? customerId : this.customerId
      }
    }

    if (!isNullOrUndefined(this.customerId)) {
      this.httpSrv.makeGetApiCall('GET_ALL_ACTIVE_APPLICATIONS', this.envService.baseUrl, options).subscribe({
        next: (applicationList: any) => {
          let { response } = applicationList;

          if (response && response.length > 0) {
            this.applicationsList = response;
          }
          if (this.applicationsList.length > 0) {
            this.applicationNames = this.applicationsList.map((item: any) => item.applicationName);
            this.applicationIds = this.applicationsList.map((item: any) => item.applicationId);
            this.initializeApplicationMaps();
          }
        },
        complete: () => {},
        error: (err: any) => {
          console.log("Error in fetching applications list ", err);
          this.utilSrv.showToastMessage("Error in fetching applications list", "err");
        }
      });
    }
  }

  // * Set all application selected status to false initially
  // * Build a map of application names to application ids
  initializeApplicationMaps() {

    this.applicationNames.forEach((name: string, index: number) => {

      let applicationObj = this.applicationsList.filter((item: any) => item.applicationName === name)[0];

      if (!isNullOrUndefined(applicationObj)) {

        let { isApplicationAssigned, resourceActionIds } = applicationObj;

        this.applicationSelectedStatus[name] = isApplicationAssigned;

        this.applicationNameIdMap[name] = this.applicationNameIdMap[name]
          ? this.applicationNameIdMap[name]
          : this.applicationIds[index];

        this.applicationNameResourceActionIdMap[name] = this.applicationNameResourceActionIdMap[name]
          ? this.applicationNameResourceActionIdMap[name]
          : resourceActionIds;
      }
    })

    this.applicationSelectedStatusCopy = { ...this.applicationSelectedStatus };
  }

  toggleApplicationSelectedStatus(applicationName: string, id: any) {
    this.applicationSelectedStatus[applicationName] = !this.applicationSelectedStatus[applicationName];
    if (this.applicationSelectedStatus[applicationName] == false) {
      this.unchekedList.push(applicationName)
    }
    else {
      this.chekedList.push(id)
      for (let key in this.unchekedList) {
        if (this.unchekedList[key] == applicationName)
          this.unchekedList[key] = null
        delete this.unchekedList[key]
      }
    }
    this.isButtonEnabled = this.enableOrDisableButton();
  }

  enableOrDisableButton(): boolean {

    for (let applicationName in this.applicationSelectedStatusCopy) {

      let existingStatus = this.applicationSelectedStatusCopy[applicationName];
      let currentStatus = this.applicationSelectedStatus[applicationName];

      if ((existingStatus === true && currentStatus === false) ||
        (existingStatus === false && currentStatus === true)) {
        return true;
      }
    }

    return false;
  }

  assignOrUpdateApplications() {

    let { ALLOCATE_APPLICATIONS } = USER_MGMT_CNST.OPERATION_TYPES;

    let postData: {
      "customerId": any,
      "assignedApplications": any[],
      "deletedApplications": any[],
      "resourceActionIds": any[]
    } = {
      "customerId": null,
      "assignedApplications": [],
      "deletedApplications": [],
      "resourceActionIds": []
    }

    //* If assign applications was clicked to open the modal
    if (Object.keys(this.applicationsResourcesInfo).length > 0) {
      for (let applicationName in this.applicationSelectedStatus) {
        let applicationStatus = this.applicationSelectedStatus[applicationName];

        if (applicationStatus) {
          let applicationId = this.applicationNameIdMap[applicationName];
          postData.assignedApplications.push(applicationId);
        }
      }
    }
    //* Existing applications are updated
    else {
      for (let applicationName in this.applicationSelectedStatusCopy) {

        let existingStatus = this.applicationSelectedStatusCopy[applicationName];
        let currentStatus = this.applicationSelectedStatus[applicationName];

        let applicationId = this.applicationNameIdMap[applicationName];

        // Deleted Applications Array
        if (existingStatus === true && currentStatus === false) {
          postData.deletedApplications.push(applicationId);

          let resourceIdsForUnAssignedApp = this.applicationNameResourceActionIdMap[applicationName];
          postData.resourceActionIds.push(...resourceIdsForUnAssignedApp);

        } else if (existingStatus === false && currentStatus === true) {
          postData.assignedApplications.push(applicationId);
        }
      }
    }

    if (!isNullOrUndefined(this.customerId)) {
      postData.customerId = this.customerId;
    }


    this.httpSrv.makePostApiCall('ASSIGN_UPDATE_CUSTOMER_APPLICATIONS', postData, this.envService.baseUrl).subscribe({
      next: () => {
        this.utilSrv.showToastMessage("Applications assigned/updated successfully ", "success");
      },
      complete: () => {},
      error: (err: any) => {
        console.log("Error in assigning/updating applications ", err);
        this.utilSrv.showToastMessage("Error in assigning/updating applications", "error");
      }
    });
  }

  navigateToEdit() {
    this.router.navigate(['um', 'customer', 'addCustomer'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    this.modal.dismissAll();
  }
}
